
export function get_version() {
  return process.env.VERSION
}



// WEBPACK FOOTER //
// ./src/utils/get_version.js